<template>
  <div class="card-detail-for-maintenance">
    <div v-if="list.length" class="flex-box">
      <template v-for="(item, index) in list">
        <div :key="index" :class="['card-box']">
          <img v-if="item.winTheBidFlag" :src="require('@/assets/imgs/win_the_bid.png')" class="be-selected" />
          <img v-else-if="item.enteredFlag" :src="require('@/assets/imgs/be_selected.png')" class="be-selected" />
          <div class="line"></div>
          <div class="title-box">
            <div class="supplier">
              <SupplierNameStatus :outsidePlugin="false" :info="item" />
            </div>
          </div>
          <div class="item">
            <span class="label">报价总额: </span>
            <el-popover
              v-if="zgyFlag"
              placement="bottom-start"
              width="1200"
              trigger="hover">
              <div style="max-height: 600px; overflow: auto;">
                <div style="position: relative;">
                  <BaseInfo :outsidePlugin="false" :info="item" />
                </div>
                <QuotationTableNonMaintenance :info="item" />
              </div>
              <span slot="reference" class="value amount">￥{{ item.totalAmount || '--' }}</span>
            </el-popover>
            <span v-else class="value" style="font-weight: bold;">￥{{ item.totalAmount || '--' }}</span>
          </div>
          <div class="item">
            <span class="label">发票: </span>
            <span class="value">{{ item.invoiceTypeDesc }}；{{ item.taxRate !== null ? `${ (item.taxRate * 100).toFixed(0) }%` : '' }}</span>
          </div>
          <div class="item">
            <span class="label">交付方式: </span>
            <span class="value">{{ item.deliveryMethodDesc || '--' }}</span>
          </div>
          <div class="item">
            <span class="label">计划交付时间: </span>
            <span class="value">{{ formatter(item.plannedDeliveryDate, 'YYYY-MM-DD') }}</span>
          </div>
          <div v-if="zgyFlag" class="item">
            <span class="label">报价轮次: </span>
            <span
              @click="showHistoryQuotation(item.tenantId, item.versionNo)"
              :class="['value', item.versionNo * 1 > 1 ? 'rounds' : '']">
              {{ item.versionNo || '--' }}
            </span>
          </div>
          <div class="item">
            <span class="label">报价时间: </span>
            <span class="value">{{ formatter(item.createTime) }}</span>
          </div>
        </div>
      </template>
    </div>

    <el-empty v-else :image="require('@/assets/imgs/default.svg')" description="暂无数据"></el-empty>

    <!-- 历史报价 -->
    <QuotationHistory ref="QuotationHistory" />
  </div>
</template>
<script>
import { dateFormat } from '@/utils/dateFormat';
import SupplierNameStatus from './quotation/supplierNameStatus.vue';
import BaseInfo from './quotation/baseInfo.vue';
import QuotationTableNonMaintenance from './quotation/quotationTableNonMaintenance.vue';
import QuotationHistory from './quotation/quotationHistory.vue';
import { listByInquireQuote } from '@/api/RFQ';

export default {
  props: {
    zgyFlag: {
      type: Boolean,
      default: true,
    },
    inquirePriceId: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    quotePriceStatus: {
      type: String,
      default: '',
    },
    orderByProperty: {
      type: String,
      default: 'totalAmount',
    },
  },
  components: {
    SupplierNameStatus,
    BaseInfo,
    QuotationTableNonMaintenance,
    QuotationHistory,
  },
  watch: {
    orderByProperty () {
      this.queryLists();
    },
  },
  data () {
    return {
      list: [],
    };
  },
  methods: {
    formatter: (v, type = 'YYYY-MM-DD HH:mm:ss') => {
      return v * 1 ? dateFormat(v).format(type) : '--';
    },
    showHistoryQuotation (tenantId, versionNo) {
      if (versionNo * 1 <= 1) return;
      this.$refs.QuotationHistory.inquirePriceId = this.inquirePriceId; // 询价单id
      this.$refs.QuotationHistory.tenantId = tenantId; // 供应商id
      this.$refs.QuotationHistory.queryHistoryQuotePriceList();
      this.$refs.QuotationHistory.showDialog = true;
    },
    refresh () {
      this.queryLists();
    },
    async queryLists () {
      this.list = [];
      const params = {
        findItemFlag: true,
        findNotQuoteSupplierFlag: true,
        findQuoteAnnexFlag: true,
        inquirePriceId: this.inquirePriceId,
        inquireQuotePriceIds: [],
        orderBy: [
          {
            orderByProperty: this.orderByProperty,
            orderByType: this.orderByProperty === 'lastUpdateTime' ? 'DESC' : 'ASC',
          },
        ],
      };
      const { body } = await listByInquireQuote(params);
      this.list = body || [];
    },
  },
  mounted () {
    this.queryLists();
  },
};
</script>
<style lang="scss" scoped>
.card-detail-for-maintenance {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .flex-box {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .card-box {
    display: inline-block;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(80, 87, 102, 0.1);
    border-radius: 8px;
    border: 1px solid #EBEEF5;
    padding: 15px;
    padding-bottom: 5px;
    margin: 0 8px;
    margin-bottom: 15px;
    width: 23%;
    min-width: 288px;
    position: relative;
    .be-selected {
      width: 60px;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 40px;
    }
    .line {
      width: 4px;
      height: 16px;
      background: #0091FF;
      border-radius: 0px 25px 25px 0px;
      position: absolute;
      top: 14px;
      left: 0;
    }
    .title-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 20px;
      .supplier {
        display: inline-block;
        width: 100%;
        position: relative;
        top: -13px;
        left: -5px;
      }
    }
    .item {
      padding: 4px 0;
      .label {
        // font-size: 12px;
        color: #909399;
      }
      .value {
        // font-size: 12px;
        color: #303133;
      }
      .amount {
        cursor: pointer;
        font-size: 14px;
        color: #0091FF;
        font-weight: bold;
      }
      .rounds {
        cursor: pointer;
        font-weight: bold;
        color: #0091FF;
      }
    }
    .ctrl-bar {
      border-top: 1px solid #eeeeee;
      margin-top: 10px;
      text-align: right;
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
